export default {
    timer: {}
}